
import { defineComponent, ref } from "vue";
import firebase from "../firebase/firebase";
import InputText from "primevue/inputtext";

export default defineComponent({
  name: "SetTitle",
  components: { InputText },
  props:{
    placeholder:{
      type: String,
      default:"表示される楽曲のタイトル",
    }
  },
  setup() {
    return {
      title: ref(),
    };
  },
});
